import 'jquery-ui/ui/widgets/autocomplete'
import $ from 'jquery'
import CONSTS from '../constants'
import Component from './component'
import { Modal } from 'bootstrap'

export class Cart extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      notification: '.js-cart-notification',
      cartItem: '.js-cart-item',
      cartItemNumber: '.js-cart-item-',
      cartItemQuantityInput: '.js-cart-item-quantity-input',
      cartItemRemove: '.js-cart-item-remove',
      cartSubTotal: '.js-cart-subtotal',
      cartSubTotalRow: '.js-cart-subtotal-row',
      cartTotalDiscount: '.js-cart-totaldiscount',
      cartTotalDiscountRow: '.js-cart-totaldiscount-row',
      cartTotal: '.js-cart-total',
      form: '.js-cart-form',
      submit: '.js-cart-submit',
      suggestInput: '.js-cart-suggest-input',
      suggestProductRow: '.js-cart-suggest-input-row',
    })

    // classStates extensions
    Object.assign(this.classStates, {
      highlight: 'h-state--highlight',
    })

    this.$cartSubTotal = this.$ctx.find(this.classes.cartSubTotal)
    this.$cartSubTotalRow = this.$ctx.find(this.classes.cartSubTotalRow)
    this.$cartTotalDiscount = this.$ctx.find(this.classes.cartTotalDiscount)
    this.$cartTotalDiscountRow = this.$ctx.find(
      this.classes.cartTotalDiscountRow
    )
    this.$cartTotal = this.$ctx.find(this.classes.cartTotal)
    this.$form = this.$ctx.find(this.classes.form)
    this.$submit = this.$ctx.find(this.classes.submit)

    this.$suggestProductRow = this.$ctx.find(this.classes.suggestProductRow)
    this.$suggestForm = this.$suggestProductRow.find('form')
    this.$suggestInput = this.$ctx.find(this.classes.suggestInput)

    this.hideNotification()

    this.bindModals()
    this.bindProductRemoveSubmit()
    this.bindProductUpdateSubmit()
    this.bindSubmit()
    this.bindSuggestInput()
  }

  hideNotification() {
    const DELAY = 5000
    this.$notification = this.$ctx.find(this.classes.notification)

    if (this.$notification.length > 0) {
      window.setTimeout(() => this.$notification.hide(), DELAY)
    }
  }

  bindModals() {
    const modalTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="modal"]')
    )
    this.modalList = modalTriggerList.map((el) => new Modal(el))
  }

  bindProductRemoveSubmit() {
    this.$ctx.on('click', this.classes.cartItemRemove, (event) => {
      event.preventDefault()

      const $me = $(event.currentTarget)
      const $form = $me.closest('form')
      const $item = $me.closest(this.classes.cartItem)

      $.ajax({
        type: 'POST',
        data: $form.serialize(),
        dataType: 'json',
        url: $form.data('action-remove'),
        success: (data) => {
          if (data.status === 'success') {
            // update notification
            this.ev.emit(
              CONSTS.EVENTS.UPDATE_CART_QUANTITY,
              data.totalQuantity,
              true
            )

            // update subtotal
            this.updateSubTotal(data.subtotalPrice)
            // update discount
            this.updateTotalDiscount(data.totalDiscount)
            // update total incl. discount
            this.$cartTotal.html(data.totalPrice)

            // remove cart item
            $item.remove()
          }
        },
        error: () => false,
      })
    })
  }

  bindProductUpdateSubmit() {
    this.$ctx.on('change', this.classes.cartItemQuantityInput, (event) => {
      const $me = $(event.currentTarget)
      const $form = $me.closest('form')

      $.ajax({
        type: 'POST',
        data: $form.serialize(),
        dataType: 'json',
        url: $form.attr('action'),
        success: (data) => {
          if (data.status === 'success') {
            // update notification
            this.ev.emit(
              CONSTS.EVENTS.UPDATE_CART_QUANTITY,
              data.totalQuantity,
              true
            )

            // update subtotal
            this.updateSubTotal(data.subtotalPrice)
            // update discount
            this.updateTotalDiscount(data.totalDiscount)
            // update total incl. discount
            this.$cartTotal.html(data.totalPrice)
          }
        },
        error: () => false,
      })
    })
  }

  bindSubmit() {
    this.$submit.on('click', (event) => {
      event.preventDefault()
      this.$form.trigger('submit')
    })
  }

  bindSuggestInput() {
    if (this.$suggestInput.length > 0) {
      // eslint-disable-next-line consistent-this
      const self = this

      this.$suggestForm.on('submit', (event) => {
        event.preventDefault()
      })

      this.$suggestInput.autocomplete({
        minLength: 2,
        appendTo: this.$suggestProductRow,
        create: () => {
          this.$suggestInput.data('ui-autocomplete')._renderItem = function (
            ul,
            item
          ) {
            const reg = new RegExp(`^${this.term}`, 'i')
            const t = item.label.replace(
              reg,
              `<span class="${self.classStates.highlight}">$&</span>`
            )

            return $('<li>')
              .data('item.autocomplete', item)
              .append(`<a>${t}</a>`)
              .appendTo(ul)
          }
        },
        source: (request, response) => {
          $.ajax({
            type: 'POST',
            data: this.$suggestForm.serialize(),
            dataType: 'json',
            url: this.$suggestForm.attr('action'),
            success: (data) => response(data),
            error: () => false,
          })
        },
        select: (event, ui) => {
          const DELAY = 1400

          // define selectors
          const $row = $(ui.item.row)
          const $input = $row.find(this.classes.cartItemQuantityInput)
          const $rowExists = this.$ctx.find(
            this.classes.cartItemNumber + ui.item.id
          )

          // check if alreay exists -> flash
          if ($rowExists.length > 0) {
            $rowExists.addClass(this.classStates.highlight)

            window.setTimeout(() => {
              $rowExists.removeClass(this.classStates.highlight)
            }, DELAY)
          } else {
            // add row to cart
            this.$suggestProductRow.before($row)

            // update backend by triggering form submit
            $input.trigger('change')
          }

          // reset input field
          this.$suggestInput.val('')

          return false
        },
      })
    }
  }

  updateSubTotal(subTotalPrice) {
    this.$cartSubTotal.html(subTotalPrice)

    if (window.parseFloat(subTotalPrice) > 0) {
      this.$cartSubTotalRow.removeClass(this.classStates.hidden)
    } else {
      this.$cartSubTotalRow.addClass(this.classStates.hidden)
    }
  }

  updateTotalDiscount(totalDiscount) {
    this.$cartTotalDiscount.html(totalDiscount)

    if (window.parseFloat(totalDiscount) > 0) {
      this.$cartTotalDiscountRow.removeClass(this.classStates.hidden)
    } else {
      this.$cartTotalDiscountRow.addClass(this.classStates.hidden)
    }
  }

  onResize() {
    // noop
  }
}
